module.exports = __webpack_public_path__ + "static/media/tschelogo.807b6f86.png";